const SUCCESS = 'success';
const ERROR = 'error';
const WARNING = 'warning';

export default {
    SUCCESS,
    ERROR,
    WARNING,
};